module.exports = __webpack_public_path__ + "static/media/Gosch_Carola-078R13x18_wide.0ad8ddb9.jpg";